import styled from 'styled-components';
import { s } from './NPL.styles';
import { ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface IProfitAnalysisProps {
  revenueAnalysis: ReturnType<NplCalculation['getRevenueAnalysis']>;
}

const ProfitAnalysis = (props: IProfitAnalysisProps) => {
  const { revenueAnalysis } = props;
  return (
    <s.Div style={{ marginBottom: '0px' }}>
      <s.Title>수익분석</s.Title>
      <div>
        <s.Grid>
          <s.InfoCell backgroundColor="#F7F8FC" style={{ gap: '2px' }}>
            <s.CellTitle>A안</s.CellTitle>
            <s.CellContent>자기자본 투자</s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F7F8FC" style={{ gap: '2px' }}>
            <s.CellTitle>B안</s.CellTitle>
            <s.CellContent>레버리지 투자</s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>예상배당액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>예상배당액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>경매비용 환수금액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>경매비용 환수금액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>(A안) 총투자비용</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row3_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>(B안) 총투자비용</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row3_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>-</s.CellTitle>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>질권대출 상환금액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row4)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle color="#008AFF">예상수익금액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row5_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle color="#008AFF">예상수익금액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row5_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>
              총투자비용 대비
              <br />
              예상수익률
            </s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row6_1, true, true)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>
              총투자비용 대비
              <br />
              예상수익률
            </s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row6_2, true, true)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle color="#008AFF">예상수익률(年利)</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row7_1, true, true)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle color="#008AFF">예상수익률(年利)</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row7_2, true, true)}
            </s.CellContent>
          </s.InfoCell>
        </s.Grid>
        <s.BlueSmallText>
          *예상수익률은 예상배당액 및 총투자비용에 따라 변동될 수 있음
        </s.BlueSmallText>
      </div>
    </s.Div>
  );
};

export default ProfitAnalysis;
